<form class="cpp-search" (submit)="onSubmit()" [formGroup]="searchForm" id="cpp-search"
  [ngClass]="{'_has-error': searchForm.controls.input.invalid}"
  >
  <input class={{cssInput}} [autocomplete]="name" [name]="name" [value]="value" type="search" formControlName="input" [attr.placeholder]="placeholder"/>
  <button class="cpp-button cpp-button--happy" type="submit">
    <svg width="18" height="18" fill="#FFF">
      <title>{{submitText}}</title>
      <use xlink:href="#Search"></use>
    </svg>
  </button>
</form>
<u4-cpp-input-error [control]="searchForm.get('input')">
</u4-cpp-input-error>

